import { hideAlert } from '../actions/index'
import AlertComponent from '../components/AlertComponent'
import { connect } from 'react-redux';
const mapStateToProps = (state) => {
	return {
			show: state.ui.showAlert,
			message: state.ui.alertMessage
	}
}
const mapDispatchToProps = (dispatch, ownProps) => ({
  	hide: () => {
		dispatch(hideAlert());
    }
})



let AlertContainer = connect(mapStateToProps, mapDispatchToProps)(AlertComponent);
export default AlertContainer;
